import React, { useEffect, useState } from 'react'
import { injectIntl } from "react-intl";
import './style.scss';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import TableGridView from '../TableGridView';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import { updateChangeStatusAppointmentRequest, getLabtestsListRequest, deleteAppointmentLabtestRequest, getAppointmentRequest, getPatientLabtestsRequest, getAppointmentReasonsRequest, changeStatusAppointmentRequest, setAddedReason, sendToPatientRequest } from '../../store/appointments/actions';
import SuggessionForm from './SuggessionForm';
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import TaskForm from '../TaskForm/TaskForm';
import { homeTaskIcon, geneticTree, avatar, men1, /* men2, men3, */ women1, /* women2, women3, */ call, video, office, whatsapp  } from '../../utils/images';
import moment from 'moment';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import CancelForm from './CancelForm';

function CurrentAppointment( { intl: { messages } } ) {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { appointment, patientLabtests, appointmentReasons, addedReason, sentToPatient } = useSelector((state) => state.appointments);
    const user = useSelector((state) => state.auth?.user?.data);
    const lang = localStorage.getItem('lang');
    const [openModal, setOpenModal] = useState(false);
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [selectedTest, setSelectedTest] = useState(null);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [isNewReason, setIsNewReason] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [reasons, setReasons] = useState([]);
    const mens = [men1];
    const womens = [women1];
    const [formData, setFormData] = useState({
        status: null,
        appointment_reason_id: 0,
        reason: '',
        notes: '',
    });
    const [copied, setCopied] = useState(null);

    useEffect(() => {
      if (id) {
        dispatch(getAppointmentRequest(id));
        dispatch(getLabtestsListRequest());
        dispatch(getAppointmentReasonsRequest());
      }
    }, [dispatch, id]);

    useEffect(() => {
      if (appointment && appointment.patient_id) {
        dispatch(getPatientLabtestsRequest({
          page: 1,
          sort: 'id,desc',
          requestId: appointment?.request_id,
        }, appointment?.patient_id));

        setFormData({
            ...formData,
            status: appointment.status,
            appointment_reason_id: appointment?.appointment_reason_id || 0,
            reason: appointment?.reason || '',
            notes: appointment?.notes || '',
        });

        if (appointment?.appointment_reason_id && appointment?.appointment_reason_id !== 0) {
          dispatch(setAddedReason(true));
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, appointment]);

    useEffect(() => {
      if (appointmentReasons && appointmentReasons.length) {
        setReasons(appointmentReasons);
      }
    }, [appointmentReasons]);

    useEffect(() => {
      if (copied) {
        setTimeout(() => {
          setCopied(null);
        }, 2000);
      }
    }, [copied]);

      //table n grid view render
    const headings = [
        messages.appointments.app_test_name,
        messages.appointments.app_suggession,
        messages.appointments.app_actions,
    ];

    const renderTableData = () => {
      return patientLabtests?.data?.map((app, i) => {
        const { lab_test_name, notes, reference_lab } =
          app;
        return [
          `${lab_test_name}-${lang === 'ar' ? reference_lab?.ar ? reference_lab?.ar : reference_lab?.en : reference_lab?.en}`,
          notes,
          <div className="table-actions">
            <DeleteForeverIcon 
              className={sentToPatient || appointment?.status === 4 || appointment?.status === 5 ? 'disabled' : ''}
              onClick={() => {
              setSelectedTest(app);
              setDeleteConfirmation(true);
              }} />
            <EditIcon 
              className={sentToPatient || appointment?.status === 4 || appointment?.status === 5 ? 'disabled' : ''}
              onClick={() => {
              setSelectedTest(app);
              setOpenModal(true);
              }} />
          </div>,
        ];
      });
    };

    const handlePageChange = (e, page) => {
        return dispatch(
          getPatientLabtestsRequest({
              page,
              sort: 'created_at,desc',
              requestId: appointment?.request_id,
          }, appointment.patient_id));
    };

    const reloadData = () => {
      //clear
    };

    useEffect(() => {
      if (formData.appointment_reason_id === 'new') {
        setIsNewReason(true);
      } else {
        setIsNewReason(false);
      }
    }, [formData.appointment_reason_id]);

    useEffect(() => {
      if (formData.status === 3) {
        setReasons(appointmentReasons?.filter(reason => reason.type === 1));
      } else if (formData.status === 5) {
        setReasons(appointmentReasons?.filter(reason => reason.type === 2));
      } else {
        setReasons(appointmentReasons);
      }
    }, [formData.status, appointmentReasons]);

    const handleSave = () => {
      //console.log(formData);
      if (parseInt(formData.appointment_reason_id) === 0) {
        document.getElementById('nextStep').style.borderColor = '#C00';
        return
      }
      if (addedReason) {
        setIsEditMode(true);
        dispatch(setAddedReason(false));
      } else {
        if (isEditMode) {
          if (formData.appointment_reason_id === 'new') {
            dispatch(updateChangeStatusAppointmentRequest({ ...formData, id: appointment.id, appointment_reason_id: null }));
          } else {
            dispatch(updateChangeStatusAppointmentRequest({ ...formData, id: appointment.id, reason: null }));
          }
        } else {
          if (formData.appointment_reason_id === 'new') {
            dispatch(changeStatusAppointmentRequest({ ...formData, id: appointment.id, appointment_reason_id: null }));
          } else {
            dispatch(changeStatusAppointmentRequest({ ...formData, id: appointment.id, reason: null }));
          }
        }
      }
    };

    const copyToClipboard = () => {
        var text = appointment?.join_url;
        navigator.clipboard.writeText(text).then(function() {
          setCopied(true)
          console.log('Async: Copying to clipboard was successful!');
        }, function(err) {
          console.error('Async: Could not copy text: ', err);
        });
    }

    if (parseInt(appointment?.status) === 1) return 'Appointment Not Active';

    return (
        <div className={`current_app ${parseInt(appointment?.type) === 2 && 'videocall'}`}>
            <div className='row'>
                <div className='col-md-8'>
                    <div className='current_app_status'>
                        {/* <h3>{messages.appointments.app_status}</h3> */}
                    </div>
                    <div className='current_app_tests'>
                        <h3>{messages.appointments.app_tests}</h3>
                        <div className='current_app_tests_table'> 
                          {
                            patientLabtests?.data?.length > 0 ? (
                              <TableGridView
                                  title={null}
                                  Form={null}
                                  table={{
                                      stickyHeader: true,
                                      headings: headings,
                                      data: renderTableData(),
                                      headClass: "bg-white table-head",
                                      noData: messages.appointments.no_data,
                                  }}
                                  pagination={{
                                    count: patientLabtests?.last_page,
                                    page: patientLabtests?.current_page,
                                    handleChange: handlePageChange,
                                  }}
                              />
                            ) : (
                              <div className='no_data'>
                                {messages.appointments.no_data}
                              </div>
                            )
                          }
                          
                          <div className='btn_coontainer'>
                              <button type='button' disabled={sentToPatient  || appointment?.status === 1 || appointment?.status === 4 || appointment?.status === 5 || appointment?.status === 6}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedTest(null);
                                  setOpenModal(true);
                              }}>{messages.appointments.app_add_test}</button>
                          </div>
                        </div>
                        <div className='section_action'>
                            <button type='button' disabled={sentToPatient  || appointment?.status === 1 || appointment?.status === 4 || appointment?.status === 5 || appointment?.status === 6}
                              onClick={(e) => {
                                e.preventDefault();
                                dispatch(sendToPatientRequest(appointment?.patient_id))
                            }}>{messages.appointments.send_btn}</button>
                        </div>
                    </div>
                    <div className='btns-container'>
                      <div className="newTaskBtn" onClick={(e) => setShowForm(true)}>
                          <span>{messages.home.taskBtn}</span>
                          <img src={homeTaskIcon} alt="users" />
                      </div>
                      <a className="newTaskBtn" href='https://pedigree.progenygenetics.com/' target='_blank' rel="noreferrer" >
                          <span>{messages.home.tree}</span>
                          <img src={geneticTree} alt="tree" />
                      </a>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='upcomming_contanier'>
                        <div className='next_container'>
                            <h3>{messages.appointments.current}</h3>
                            <div className="next_img">
                                <img src={appointment?.patient_gender_type 
                                      ? appointment?.patient_gender_type === 1 ? mens[Math.floor(Math.random() * mens.length)] : appointment?.patient_gender_type === 2 ? womens[Math.floor(Math.random() * womens.length)] : avatar
                                      : avatar} alt="avatar img" />
                            </div>
                            <div className='next_title'><a href={`${window.location.origin.toString()}/patient-preview/${appointment?.patient_id}`} target="_blank" rel="noreferrer" >{appointment?.patient_name}</a></div>                            
                            <div className='next_date'>{moment(appointment?.start_date).format("dddd,\xa0 DD MMMM YYYY, h:mm a")}</div>
                            <div className='next_type'>
                                  <img src={parseInt(appointment?.type) === 1 ? whatsapp : parseInt(appointment?.type) === 2 ? video : parseInt(appointment?.type) === 3 ? call : office} alt='TypeIcon' />
                                  <span>{appointment?.purpose_name}</span>
                                  {parseInt(appointment?.type) === 2 && moment().isBetween(moment(appointment?.start_date).subtract(5, "minutes"), moment(appointment?.end_date)) && <FileCopyOutlinedIcon style={{ margin: '0 15px', cursor: 'pointer' }} onClick={() => copyToClipboard()} />}
                            </div>
                            {
                              parseInt(appointment?.type) === 2 ? (
                                <div className='btn_container'>                                  { 
                                    appointment?.status === 3 || appointment?.status === 4 || appointment?.status === 5 ? (
                                      <button className='app_btn' disabled={!appointment?.call_recording_url}>
                                              <a rel="noopener noreferrer" href={appointment?.call_recording_url} target="_blank">{messages.appointments.show_recording}</a>
                                      </button>
                                    ) : appointment?.status === 2 ? (
                                      <button disabled={!moment().isBetween(moment(appointment?.start_date).subtract(5, "minutes"), moment(appointment?.end_date))}
                                              className='app_btn'>
                                                <a rel="noopener noreferrer" href={appointment?.join_url} target="_blank">{messages.appointments.start_app}</a>
                                      </button>
                                    ) : null
                                  }
                                </div>
                              ) : parseInt(appointment?.type) === 1 || parseInt(appointment?.type) === 3 ? (
                                <div className='phonenumber_container'>
                                  <span>{appointment?.patient_phone_number}</span>
                                </div>
                              ) : 
                                <div className='phonenumber_container'>
                                  <span>{messages.appointments.genome_office}</span>
                                </div>
                            }
                            <div className='form-group'>
                                  <label className="checkbox-container">{messages.appointments.done}
                                      <input type="radio" name="familyHistory" 
                                              checked={formData.status === 3 ||formData.status === 4}
                                              value={3 || 4}
                                              disabled={addedReason}
                                              onChange={(e) => {
                                                  setFormData({
                                                      ...formData,
                                                      status: parseInt(e.target.value),
                                                      appointment_reason_id: 0,
                                                      reason: null,
                                                  });

                                              }} />
                                      <span className="checkmark"></span>
                                  </label>
                                  <label className="checkbox-container">{messages.appointments.cancel}
                                      <input type="radio" name="familyHistory" 
                                              checked={formData.status === 5}
                                              disabled={addedReason}
                                              value={5}
                                              onChange={(e) => {
                                                  setFormData({
                                                      ...formData, 
                                                      status: parseInt(e.target.value),
                                                      appointment_reason_id: 0,
                                                      reason: null,
                                                  });
                                              }} />
                                      <span className="checkmark"></span>
                                  </label>
                              </div>
                              <div className='form-container'>
                                <label htmlFor="nextStep" className='required'>{formData.status === 3 ? messages.appointments.next_step : messages.appointments.reason}</label>
                                {
                                  addedReason ? (
                                    <p>{ formData.appointment_reason_id !== "new" && parseInt(formData.appointment_reason_id) > 0 ? reasons?.find(reason => parseInt(reason.id) === parseInt(formData.appointment_reason_id))?.reason : formData.reason}</p>
                                  ) : (
                                    isNewReason ? (
                                      <div className='new_reason_input'>
                                        <input type='text' id='newReason' name='newReason' 
                                            placeholder={messages.appointments.new_reason}
                                            onChange={(e) => {
                                              setFormData({
                                                ...formData,
                                                reason: e.target.value,
                                              })
                                            }}
                                            onKeyDown={e => {
                                              if (e.key === "Enter") {
                                                setReasons([ ...reasons, { id: "new", reason: formData.reason } ]);
                                                setIsNewReason(false);
                                                setFormData({
                                                  ...formData,
                                                  appointment_reason_id: "new",
                                                })
                                              }
                                            }}  
                                        />
                                        <CheckIcon onClick={() => {
                                          setReasons([ ...reasons, { id: "new", reason: formData.reason } ]);
                                          setIsNewReason(false);
                                          setFormData({
                                            ...formData,
                                            appointment_reason_id: "new",
                                          })
                                        }}/>
                                        <CloseIcon onClick={() => {
                                          setIsNewReason(false);
                                          setFormData({
                                            ...formData,
                                            appointment_reason_id: 0,
                                            reason: '',
                                          })
                                        }} />
                                      </div>
                                    ) : (
                                      <select name="nextStep" id="nextStep"
                                          value={formData.appointment_reason_id}
                                          onChange={e => {
                                              document.getElementById('nextStep').style.borderColor = '#eee';
                                              setFormData({ ...formData, appointment_reason_id: e.target.value })
                                              }}
                                          >
                                          <option value={0}>{messages.appointments.next_step_placeholder}</option>
                                          {reasons?.map(step => <option key={step.id} value={step.id}>{step.reason}</option>)}
                                          {!reasons.find(reason => reason.id === 'new') && <option value={'new'} style={{ color: '#24d7d3' }} >{messages.appointments.new_reason}</option>}
                                      </select>
                                    )
                                  )
                                }                
                                <label htmlFor="remarks">{messages.appointments.remarks}</label>
                                {
                                  addedReason ? (
                                    <p>{formData.notes}</p>
                                  ) : (
                                    <textarea
                                        id='remarks'
                                        name="remarks"
                                        placeholder={messages.appointments.remarks_placeholder}
                                        value={formData.notes}
                                        onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                                        rows={3}
                                        ></textarea>
                                  )
                                }

                                <div className='next_save'>
                                  <button type='button' disabled={sentToPatient  || appointment?.status === 1 || appointment?.status === 4 || appointment?.status === 6}
                                   onClick={(e) => {
                                    e.preventDefault();
                                    handleSave();
                                }}>{addedReason ? messages.appointments.edit : messages.appointments.save}</button></div>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`copied ${copied && 'show'}`}><FileCopyOutlinedIcon /> {messages.appointments.copied}</div>
            <SuggessionForm show={openModal} close={() => setOpenModal(false)} selectedTest={selectedTest} patientId={appointment?.patient_id} />
            <CancelForm show={openCancelModal} close={() => setOpenCancelModal(false)} selectedRequest={appointment?.request_id} />
            <TaskForm show={showForm} close={() => setShowForm(false)} task={null} view={false} reloadData={reloadData} />
            <ConfirmDialog show={deleteConfirmation} 
                     onCancel={() => setDeleteConfirmation(false)}
                     onConfirm={() => {
                        dispatch(deleteAppointmentLabtestRequest(selectedTest.id, appointment.patient_id));
                        setDeleteConfirmation(false);
                     }}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
            {
              user?.role_id < 4 && (appointment?.request_status < 6 || appointment?.request_status > 12) ? (
                <div className='cancel_section'>
                    <p><span className='cancel_section_badge'>&nbsp;</span>{messages.appointments.cancel_feedback}</p>
                    <button type="button" className="cancel_section_button" onClick={(e) => {e.preventDefault(); setOpenCancelModal(true)}}>{messages.appointments.cancel_btn}</button>
                </div>
                ) : null
            }   
        </div>
    )
}

export default injectIntl(CurrentAppointment)